import { render } from "./JobInfo.vue?vue&type=template&id=4613811b&scoped=true"
import script from "./JobInfo.vue?vue&type=script&lang=js"
export * from "./JobInfo.vue?vue&type=script&lang=js"

import "./JobInfo.vue?vue&type=style&index=0&id=4613811b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4613811b"]])

export default __exports__